export default __webpack_public_path__ + "static/media/RICHARD HILL.a673a406.jpg";